import React, {useState} from 'react';
import styles from './CharacteristicsE.scss';
import blockStyles from "@baseStyles/block.scss";
import language from "@lang/language";
import ContentB1 from "@components/blocks/ContentB1/ContentB1";
import Button from "@components/base/Button/Button";
import ContentB4 from "@components/blocks/ContentB4/ContentB4";
import Price from "@components/base/Price/Price";
import TermSelector from "@components/base/TermSelector/TermSelector";
import useDockedTable from "@hooks/useDockedTable";
import useDataFileAction from "@hooks/useDataFileAction";

const CharacteristicsE = ({data, color = ''}) => {

	if (!data) {
		return null;
	}

	const serviceParams = data.serviceParams ?? {};
	const [selectedTerm, setSelectedTerm] = useState(data.terms?.selected ?? 12);
	const {executeAction, ModalPortal} = useDataFileAction({term: selectedTerm});

	const hasColumnValue = (key) => (
	  data.plans?.some((plan) => {
		  const value = serviceParams?.[plan.serviceId]?.[key];
		  return value !== undefined && value !== null && value !== '';
	  }) ?? false
	);

	const showRam = hasColumnValue('ram');
	const showDisk = hasColumnValue('disk');
	const showCpu = hasColumnValue('cpu');
	const showBand = hasColumnValue('band');
	const showButton = data.plans?.some((plan) => !!plan.buttonText) ?? false;

	// Dock table thead on scroll
	//////////////////////////////////////////////////////////////////////
	useDockedTable({
		tableSelector: '.' + styles.characteristicsTable
	});

	return (
	  <>
		  {(data.blockTitle || data.blockDesc) &&
			<div className={blockStyles.baseContainerHolder}>
				{/* INTRO CONTAINER */}
				{/*///////////////////////////////////////////////////////////////////////////////*/}
				<ContentB1 title={data.blockTitle} desc={data.blockDesc}/>

				{/* Button */}
				{data.buttonText &&
				  <div className={'baseMarginBottom tcenter'}>
					  <Button
						value={data.buttonText}
						onClick={() => executeAction(data)}
					  />
				  </div>
				}
			</div>
		  }

		  <div className={`${styles.container} ${color ? blockStyles[color] : ''}`}>
			  {/* TERM SELECTOR CONTAINER */}
			  {/*///////////////////////////////////////////////////////////////////////////////*/}
			  {data.terms &&
				<TermSelector
				  data={data.terms}
				  selectedTerm={selectedTerm}
				  onChange={setSelectedTerm}
				  color={color}
				/>
			  }

			  {/* TABLE */}
			  {/*///////////////////////////////////////////////////////////////////////////////*/}
			  <div className={styles.tableWrap}>
				  <table className={styles.characteristicsTable}>
					  <thead>
					  <tr>
						  <th>{language.plan}</th>
						  {showRam && <th>RAM</th>}
						  {showDisk && <th>{language.ssdDisk}</th>}
						  {showCpu && <th>CPU</th>}
						  {showBand && <th>{language.monthTraffic}</th>}
						  <th>{data.priceColumnText}</th>
						  {showButton && <th>&nbsp;</th>}
					  </tr>
					  </thead>
					  <tbody>
					  {data.plans.map((item, key) => (
						<tr key={key}>
							<th>
								<div className={styles.planHolder}>
									<div className={styles.icon}></div>
									<h2 className={`${styles.title}`}>
										{item.title}
									</h2>
								</div>
							</th>
							{showRam && (
							  <td>
								  {serviceParams?.[item.serviceId]?.ram ?
									<>
										{serviceParams?.[item.serviceId]?.ram}
									</>
									:
									<>
										-
									</>
								  }
							  </td>
							)}
							{showDisk && (
							  <td>
								  {serviceParams?.[item.serviceId]?.disk ?
									<>
										{serviceParams?.[item.serviceId]?.disk}
									</>
									:
									<>
										-
									</>
								  }
							  </td>
							)}
							{showCpu && (
							  <td>
								  {serviceParams?.[item.serviceId]?.cpu ?
									<>
										{serviceParams?.[item.serviceId]?.cpu} {serviceParams?.[item.serviceId]?.cpu === '1' ? language.cpuCore : language.cpuCores}
									</>
									:
									<>
										-
									</>
								  }
							  </td>
							)}
							{showBand && (
							  <td>
								  {serviceParams?.[item.serviceId]?.band ?
									<>
										{serviceParams?.[item.serviceId]?.band} TB
									</>
									:
									<>
										-
									</>
								  }
							  </td>
							)}
							<td className={styles.priceCol}>
								<Price
								  serviceId={item.serviceId}
								  term={selectedTerm}
								  type={item.priceType}
								  layout={'PriceI'}
								/>
							</td>
							{showButton && (
							  <td>
								  {item.buttonText &&
									<Button
									  value={item.buttonText}
									  onClick={() => executeAction(item, {
										  serviceId: item.serviceId,
										  breadCrumbMode: item.breadCrumbMode
									  })}
									/>
								  }
							  </td>
							)}
						</tr>
					  ))}
					  </tbody>
				  </table>
			  </div>

			  {/* Render modal with portal (in html.php container - <div id="modalContainer"></div>) */}
			  {/*///////////////////////////////////////////////////////////////////////////////*/}
			  {ModalPortal}
			  {/*///////////////////////////////////////////////////////////////////////////////*/}
		  </div>

		  {/* NOTES */}
		  {/*///////////////////////////////////////////////////////////////////////////////*/}
		  {data.noteData && data.noteData.length > 0 &&
			<div className={blockStyles.baseContainerHolder}>
				<ContentB4 data={data.noteData} size={'800'} color={color}/>
			</div>
		  }
	  </>
	);
}

export default CharacteristicsE;